export default "__VITE_ASSET__67$enks2__"